export default "__VITE_ASSET__6Ys56_G$__"